import styled from "styled-components";
import { MEDIA_QUERY } from "../../entities/Common";

export const HarmonyDetailsInfoStyled = styled.div`
  margin-bottom: 40px;
  padding-top: 10px;
  .harmony-details {
    &__name {
      margin-bottom: 20px;
    }
    &__left {
      width: 42%;
    }
    &__image {
      width: 100%;
      height: 380px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__right {
      width: calc(58% - 30px);
    }
    &__group {
      margin-bottom: 7.5px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_VERTICAL}) {
    .harmony-details {
      &__name + div {
        flex-wrap: wrap;
      }
      &__left {
        width: 100%;
      }
      &__right {
        width: 100%;
      }
      &__image {
        height: 100%;
        margin-bottom: 20px;
      }
    }
  }
`;
